<template>
  <b-card-code title="All Users">
    <button
      v-if="
        this.$store.state.app.user.permissions.includes('user.add_user') ||
        this.$store.state.app.user.is_staff
      "
      @click="addUser()"
      type="button"
      class="btn ml-auto btn-primary m-1"
    >
      Add New
    </button>
    <b-card-code class="bg-light-secondary " title="Search">
      <b-form inline style="display: inline-block; width: 100%">
        <div class="row" style="width: 100%; padding: 5px">
          <b-form-select
            class="ml-1"
            style="width: 30%"
            v-if="is_staff"
            @change="searchFn"
            v-model="organization"
            :options="organizations"
          >
          </b-form-select>

          <b-form-input
            class="ml-1"
            id="name"
            v-model="name_filter"
            style="width: 30%"
            name="name"
            placeholder="Search with name"
          />
          <b-button
            style="width: 12%"
            class="ml-1"
            variant="primary"
            @click="searchFn"
          >
            Search
          </b-button>
        </div>
      </b-form>
    </b-card-code>
    <div class="d-flex justify-content-center mb-1" v-if="loading">
      <b-spinner class="float-right" label="Floated Right" />
    </div>
    <b-table
      responsive
      id="orgTable"
      :fields="fields"
      :items="items"
      :per-page="perPage"
      :current-page="currentPage"
    >
      <template #cell(roles)="data">
        <b-badge
          variant="primary"
          v-for="item in data.item.groups"
          :key="item.id"
        >
          {{ item.name }}
        </b-badge>
      </template>

      <template #cell(status)="data">
        <b-badge variant="success" v-if="data.item.is_active">Yes</b-badge>
        <b-badge variant="danger" v-else>No</b-badge>
      </template>

      <template #cell(staff)="data">
        <b-badge variant="success" v-if="data.item.is_staff">Yes</b-badge>
        <b-badge variant="danger" v-else>No</b-badge>
      </template>

      <template #cell(actions)="data">
        <b-dropdown
          size="sm"
          class="ml-1"
          variant="outline-primary"
          text="Actions"
        >
          <b-dropdown-item @click="editUser(data.item.id)"
            >Edit</b-dropdown-item
          >
          <b-dropdown-item @click="inviteUser(data.item.id)"
            >Invite</b-dropdown-item
          >
          <b-dropdown-divider />
          <b-dropdown-item @click="deleteUser(data.item.id)"
            >Delete</b-dropdown-item
          >
        </b-dropdown>
      </template>
    </b-table>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      :align="pagination_pos"
      aria-controls="orgTable"
    />
  </b-card-code>
</template>

<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import { BTable } from "bootstrap-vue";
import {
  BPagination,
  BPaginationNav,
  BButton,
  BBadge,
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BForm,
  BFormInput,
  BFormSelect,
  BSpinner
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  components: {
    BCardCode,
    BTable,
    BPagination,
    BPaginationNav,
    BButton,
    BBadge,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BForm,
    BFormInput,
    BFormSelect,
    BSpinner,
  },
  data() {
    return {
      pagination_pos: "center",
      // Call orgaization API and return in this format
      items: [],
      currentPage: 1,
      perPage: 10,
      rows: 0,
      fields: [
        // { key: 'id', label: '#' },
        { key: "email", label: "Email(Username)" },
        { key: "first_name", label: "First Name" },
        { key: "last_name", label: "Last Name" },
        { key: "profile.o_profile.org_name", label: "Organization" },
        { key: "roles", label: "Roles" },
        { key: "status", label: "Status" },
        { key: "staff", label: "Staff" },
        { key: "actions", label: "Actions" },
      ],
      is_search_on: false,
      loading: false,
      is_staff: this.$store.state.app.user.is_staff,
      organization: null,
      organizations: [{ value: null, text: "--Select Organization--" }],
      name_filter: "",
    };
  },
  created: function () {
    this.load();
    this.loadOrg();
  },
  methods: {
    loadOrg: function () {
      if (this.is_staff) {
        this.loading = true;
        // Load oragnization drop down
        const o_options = {
          method: "GET",
          headers: { "content-type": "application/json" },
          url:
            process.env.VUE_APP_BASEURL +
            "organization/organization",
        };
        var self = this;
        this.$http(o_options).then((res) => {
          // console.log(res.data)
          res.data.map(function (value, key) {
            let org = {
              value: res.data[key].org_id,
              text: res.data[key].org_name,
            };
            // console.log(res.data[key].profile.organization)
            self.organizations.push(org);
          });
          this.loading = false;
        });
      } else {
        this.organization = this.$store.state.app.user.profile.organization;
        this.searchFn();
      }
    },
    load: function () {
      const options = {
        method: "GET",
        headers: { "content-type": "application/json" },
        url: process.env.VUE_APP_BASEURL + "user/users",
      };
      this.$http(options).then((res) => {
        console.log(res.data);
        // res.data.map(function(value, key) {
        //   // console.log(res.data[key].profile.organization)
        //    if(res.data[key].profile.organization != null){
        //       res.data[key].profile.organization = res.data[key].profile.o_profile.org_name
        //    }
        // });
        this.items = res.data;
        console.log(this.items);
        this.rows = res.data.length;
      });
    },
    searchFn: function (reset = true) {
      this.is_search_on = false;
      this.loading = true;
      this.filter = [];
      if (reset) this.currentPage = 1;
      let url =
        process.env.VUE_APP_BASEURL +
        "user/users?query=true" 
      // let data = {
      //     name : this.name_filter,
      //     severity : this.severity_filter,
      //     asset_id: this.asset_filter,
      //     status: this.status_filter
      // }

      if (this.organization != null) {
        this.filter.push({ organization: this.organization });
        url = url + "&q_org_id=" + this.organization;
      }
      if (this.name_filter != null && this.name_filter != "") {
        this.filter.push({ name: this.name_filter });
        url = url + "&name=" + this.name_filter;
      }

      console.log(this.filter);
      if (this.filter.length) this.is_search_on = true;
      const options = {
        method: "GET",
        headers: { "content-type": "application/json" },
        url: url,
      };
      this.$http(options).then((res) => {
        console.log(res.data);
        res.data.map(function (value, key) {
          // console.log(res.data[key].profile.organization)
          if (res.data[key].profile.organization != null) {
            res.data[key].profile.organization =
              res.data[key].profile.o_profile.org_name;
          }
        });
        this.items = res.data;
        console.log(this.items);
        this.rows = res.data.length;
        this.loading = false;
        //   this.currentPage = 1
        //   this.perPage = 10
        //   this.rows = res.data.count
      });
    },
    addUser() {
      this.$router.push({ name: "Add User" });
    },
    editUser(id) {
      this.$router.push({ name: "Edit User", params: { id: id } });
    },
    deleteUser(id) {
      if (confirm("Do you really want to delete?")) {
        const options = {
          method: "DELETE",
          headers: { "content-type": "application/json" },
          url: process.env.VUE_APP_BASEURL + "user/users/" + id + "/",
        };
        this.$http(options).then((res) => {
          console.log(res);
          this.load();
          //if(res.data.org_id){
          // this.$router.push({name: 'Organizations'});
          // }
        });
      }
    },
    inviteUser(id) {
      const options = {
        method: "POST",
        headers: { "content-type": "application/json" },
        url: process.env.VUE_APP_BASEURL + "user/users/" + id + "/invite/",
      };
      this.$http(options).then((res) => {
        console.log(res);
        if (res.data.status == "success")
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Successfully invited the user",
              icon: "EditIcon",
              variant: "success",
            },
          });
        else
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Something wrong happened. Please try again later",
              icon: "EditIcon",
              variant: "error",
            },
          });
      });
    },
  },
};
</script>